import {
  ButtonDirective,
} from 'app/components/call/BookingDetails/LessonBookingDetails/LessonOutcome/Button/ButtonDirective';
import { useI18n } from 'app/components/localization';
import ButtonClassNameA, { ColorScheme } from 'app/components/presentation/buttons/ButtonClassNameA';
import Link from 'app/components/presentation/link/Link';
import React, { FC } from 'react';
import { useBrand } from 'app/components/OrganizationContext';
import { getTutorSiteUrl } from 'app/constants/TeacherSite';
import appConfig from 'app/config/client';

export interface ILessonOutcomeButtonProps {
  colorScheme?: ColorScheme;
  directive: ButtonDirective;
  onClick: () => void;
}

/**
 * Button component that can be shared with across components that present end of lesson information.
 */
const LessonOutcomeButton: FC<ILessonOutcomeButtonProps> = ({ colorScheme, directive, onClick }) => {
  const { t } = useI18n();
  const brand = useBrand();

  let children: string;
  let to: string | null;

  switch (directive) {
    case ButtonDirective.BookLesson: {
      children = t('lesson-outcome.buttons.booking');
      to = brand.bookingUrl;
      break;
    }
    case ButtonDirective.Dashboard: {
      children = t('lesson-outcome.buttons.dashboard');
      to = brand.dashboardUrl;
      break;
    }
    case ButtonDirective.TutorDashboard: {
      children = t('lesson-outcome.buttons.tutor-dashboard');
      to = getTutorSiteUrl(appConfig.deployInfo);
      break;
    }
  }

  return (
    <ButtonClassNameA colorScheme={colorScheme}>
      {buttonClassNameA => (
        <Link className={buttonClassNameA} onClick={onClick} to={to}>
          {children}
        </Link>
    )}
    </ButtonClassNameA>
  );
};

export default LessonOutcomeButton;
